import { cn } from '../../lib/utils.ts';

type Props = {
    logoColor?: LogoColour;
    className?: string;
};

type LogoColour = 'blue' | 'black' | 'white';

const colorMap: Record<LogoColour, string> = {
    blue: '#155EEF',
    black: 'black',
    white: 'white',
};

export const PlatoLogo = ({ className = '', logoColor = 'blue' }: Props) => {
    const fill = colorMap[logoColor];

    return (
        <svg
            className={cn('h-7 w-auto', className)}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 188 188"
            fill="none"
        >
            <path
                d="M104.529 85.1824L91.3535 72.2949L37.266 125.202L50.4411 138.089L104.529 85.1824Z"
                fill={fill}
            />
            <path
                d="M126.712 146.23L93.4277 113.672L59.4498 146.908L92.7344 179.466L126.712 146.23Z"
                fill={fill}
            />
            <path
                d="M146.831 126.558L113.547 94L101.759 105.531L135.043 138.089L146.831 126.558Z"
                fill={fill}
            />
            <path
                d="M114 94.5C126.5 86 126.628 72.422 129.5 61.7433H134.608C134.88 56.741 135.083 53.0084 134.61 61.7433C134.556 62.7261 134.494 63.8668 134.423 65.1813C134.417 65.2899 134.411 65.3986 134.403 65.5074C133.326 81.2993 118.955 100.723 110.5 107.5L114 94.5Z"
                fill="#0058FF"
            />
            <path
                d="M134.403 65.5074C133.326 81.2993 118.955 100.723 110.5 107.5L114 94.5C126.5 86 126.628 72.422 129.5 61.7433H139.5M134.403 65.5074C134.411 65.3986 134.417 65.2899 134.423 65.1813C135.285 49.3038 134.769 58.7831 134.403 65.5074Z"
                stroke="#1760EB"
                strokeWidth="1.3"
            />
            <path
                d="M109.235 43.4948C103.367 55.2713 101.292 73.2385 101.5 83C101.554 85.5424 107 89 107 89C107.5 69.5 113.45 51.7947 116.572 46.0005C116.363 47.8275 118.351 53.58 127.966 61.9739C139.985 72.4662 149.038 72.3096 150.286 71.8398C151.535 71.37 153.72 63.5399 145.292 48.8193C138.549 37.0428 130.932 34.5163 127.966 34.7251C124.168 32.7415 115.104 31.7183 109.235 43.4948Z"
                fill="#1760EB"
                stroke="#1861EB"
                strokeLinejoin="round"
            />
            <path
                d="M61.8131 25.1468C76.2473 40.2836 80.8928 73.5351 81.4112 88.2687L82.5 95.2478C80.115 96.6846 75.5629 98.6962 76.4339 95.2478C77.3049 91.7995 73.9452 67.1764 68.6569 53.9937C60.5169 38.9499 45.0146 16.2135 49.3698 47.4799C53.7249 78.7462 72.5454 98.5564 81.4112 104.553L78.4559 107.5C67.6718 99.0734 44.9836 75.7064 40.504 49.6511C36.0244 23.5959 40.0892 14.0836 42.6816 12.5844C43.0445 10.4648 47.3789 10.0099 61.8131 25.1468Z"
                fill="#1760EB"
                stroke="#1760EB"
            />
        </svg>
    );
};
